import { render } from "./ForecastHeader.vue?vue&type=template&id=2079623f"
import script from "./ForecastHeader.vue?vue&type=script&lang=js"
export * from "./ForecastHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__